import { useId } from "react";

type BrandXMotifProps = {
  variant: "dark" | "light";
  size: "home" | "subpage";
  className?: string;
};

export function BrandEyebrow({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="flex shrink-0 items-center gap-1" aria-hidden="true">
        <span className="h-[3px] w-11 bg-bright-blue" />
        <span className="h-[3px] w-4 bg-brand-green" />
      </span>
      <p className="text-[13px] font-extrabold uppercase tracking-[0.2em] text-dark-green">
        {children}
      </p>
    </div>
  );
}

/** Decorative OXORY Brandset V2 X, shared by homepage and subpage heroes. */
export function BrandXMotif({ variant, size, className = "" }: BrandXMotifProps) {
  const dimensions = size === "home" ? { width: 760, height: 760 } : { width: 480, height: 480 };
  const gradientId = useId().replace(/:/g, "");
  const leftGradient = `brand-x-left-${size}-${gradientId}`;
  const rightGradient = `brand-x-right-${size}-${gradientId}`;

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 600 600"
      width={dimensions.width}
      height={dimensions.height}
      className={`brand-x-motif brand-x-motif-${size} brand-x-motif-${variant} ${className}`}
    >
      <defs>
        <linearGradient id={leftGradient} x1="0" y1="0" x2="1" y2="1">
          <stop className="brand-x-blue-start" />
          <stop offset="1" className="brand-x-blue-end" />
        </linearGradient>
        <linearGradient id={rightGradient} x1="1" y1="0" x2="0" y2="1">
          <stop className="brand-x-bright-start" />
          <stop offset="1" className="brand-x-bright-end" />
        </linearGradient>
      </defs>
      <polygon points="60,40 240,40 540,560 360,560" fill={`url(#${leftGradient})`} opacity="0.75" />
      <polygon points="360,40 540,40 240,560 60,560" fill={`url(#${rightGradient})`} opacity="0.9" />
      <polygon points="60,40 240,40 150,150" className="brand-x-green" />
    </svg>
  );
}